import type { RouteLocationRaw } from "vue-router";

import { EntityType } from "@/lib/openapi/gen/types.gen";

/** The route param each entity type is addressed by. A stek needs none; it is
 * already in the path. */
const ROUTE_BY_TYPE: Partial<
    Record<EntityType, { name: string; param?: string }>
> = {
    [EntityType.STEK]: { name: "strategyVision" },
    [EntityType.DOMAIN]: { name: "domainPage", param: "domainId" },
    [EntityType.PRODUCT]: { name: "productPage", param: "productId" },
    [EntityType.PROCESS]: { name: "processPage", param: "processId" },
    [EntityType.ROLE]: { name: "rolePage", param: "roleId" },
    [EntityType.BUSINESS_ENTITY]: {
        name: "businessEntityPage",
        param: "businessEntityId",
    },
    [EntityType.DOMAIN_TERM]: {
        name: "domainTermPage",
        param: "domainTermId",
    },
    [EntityType.APPLICATION]: {
        name: "applicationPage",
        param: "applicationId",
    },
};

export interface StekBase {
    orgName?: string;
    stekName?: string;
}

/**
 * Where an entity lives, from its type and id alone. Undefined for types that
 * need a parent (task, application entity) and for unknown ones.
 */
export const entityRouteFor = (
    entityType: string | null | undefined,
    entityId: string | null | undefined,
    base: StekBase
): RouteLocationRaw | undefined => {
    if (!entityType || !entityId || !base.orgName || !base.stekName) {
        return undefined;
    }
    const route = ROUTE_BY_TYPE[entityType as EntityType];
    if (!route) return undefined;

    return {
        name: route.name,
        params: {
            orgName: base.orgName,
            stekName: base.stekName,
            ...(route.param ? { [route.param]: entityId } : {}),
        },
    };
};
